"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commissionComponentFromObj = exports.eCommissionType = void 0;
const flatCommission_1 = __importDefault(require("./flatCommission"));
const percentageCommission_1 = __importDefault(require("./percentageCommission"));
var eCommissionType;
(function (eCommissionType) {
    eCommissionType["PERCENTAGE"] = "PERCENTAGE";
    eCommissionType["FLAT_COMMISSION"] = "FLAT_COMMISSION";
})(eCommissionType = exports.eCommissionType || (exports.eCommissionType = {}));
const commissionComponentFromObj = (data) => {
    const value = Number(data.value);
    if (!Number.isNaN(value)) {
        const partnerId = data.partnerId || data.id;
        if (data.type === eCommissionType.FLAT_COMMISSION) {
            if (!data.currency) {
                throw new Error(`Currency not specified for flat commission. PartnerId: ${partnerId}, Value: ${value}`);
            }
            return new flatCommission_1.default(data.currency, value, partnerId);
        }
        return new percentageCommission_1.default(value, partnerId);
    }
    throw new Error(`Invalid commission value provided: ${data.value}`);
};
exports.commissionComponentFromObj = commissionComponentFromObj;
//# sourceMappingURL=types.js.map